import { BackLink } from '@avanta/shared/components/BackLink';
import { Button } from '@avanta/shared/components/ui/Button';
import { Input } from '@avanta/shared/components/ui/Input';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { clearRecoveryCookies } from '@avanta/shared/utils/auth';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { ROUTES } from 'constants/routes';
import { ErrorMessage } from '../ErrorMessage';
import { initialFormData, formValidation } from './model';
import { type FormProps, type IntialFormData } from './types';

export const EmailForm = ({ onSubmit, error, isLoading }: FormProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.AUTH);
  const locationState = useLocation().state;
  const { register, handleSubmit } = useForm<IntialFormData>({
    defaultValues: { ...initialFormData, email: locationState?.email },
  });

  const handleOnSubmit = async (data: IntialFormData): Promise<void> => {
    await onSubmit(data.email);
  };

  return (
    <form onSubmit={handleSubmit(handleOnSubmit)} className="flex flex-col gap-6 w-full">
      <Input
        label={t('RecoverPassword.Form.email.label')}
        type="email"
        placeholder="ejemplo@correo.com"
        autoComplete="email"
        {...register('email', {
          required: t(formValidation.email.required),
          pattern: {
            value: formValidation.email.pattern.value,
            message: t(formValidation.email.pattern.message),
          },
        })}
      />
      <ErrorMessage message={error?.message} />
      <Button type="submit" className="w-full" disabled={isLoading}>
        {isLoading ? '...' : t('RecoverPassword.cta')}
      </Button>
      <BackLink
        label="RecoverPassword.backToLogin"
        i18nNs={LOCIZE_NS.AUTH}
        to={ROUTES.LOGIN}
        onClick={clearRecoveryCookies}
      />
    </form>
  );
};
